/**
 * Truth Ledger - Exposes attribution data for GA4 augmentation
 * 
 * This file provides a clean interface to access attribution
 * data that can be sent to GA4 as custom dimensions.
 */

var AttributionTruthLedgerEvents = (function() {
  'use strict';
  
  var ATTR_DEBUG = true;
  
  function log() {
    if (ATTR_DEBUG) console.log.apply(console, arguments);
  }
  
  /**
   * Determine paid flag based on attribution data
   * Returns: 1 (paid), 0 (organic), 'uncertain'
   */
  function getPaidFlag() {
    try {
      var stored = AttributionStorage.read();
      if (!stored) return 'uncertain';
      
      // Check if we have any paid parameters
      var firstTouch = stored.first_touch || {};
      var lastTouch = stored.last_touch || {};
      
      // Check for paid indicators
      var hasPaidParams = Object.keys(firstTouch).length > 0 || 
                          Object.keys(lastTouch).length > 0;
      
      // Check specifically for click IDs
      var hasClickId = !!(firstTouch.gclid || firstTouch.gbraid || firstTouch.wbraid ||
                          lastTouch.gclid || lastTouch.gbraid || lastTouch.wbraid);
      
      // Check for UTM parameters that typically indicate paid
      var hasPaidUtm = !!(firstTouch.utm_medium === 'cpc' || 
                          firstTouch.utm_medium === 'ppc' ||
                          lastTouch.utm_medium === 'cpc' || 
                          lastTouch.utm_medium === 'ppc');
      
      if (hasClickId || hasPaidUtm) {
        return 1; // Paid
      } else if (hasPaidParams) {
        return 1; // Has some params, likely paid
      } else {
        return 0; // Organic/direct
      }
    } catch (e) {
      log('[TruthLedger] Error getting paid flag:', e);
      return 'uncertain';
    }
  }
  
  /**
   * Get the type of click ID present
   * Returns: 'gclid', 'gbraid', 'wbraid', or 'none'
   */
  function getClickIdType() {
    try {
      var stored = AttributionStorage.read();
      if (!stored) return 'none';
      
      var firstTouch = stored.first_touch || {};
      var lastTouch = stored.last_touch || {};
      
      // Check in priority order
      if (firstTouch.gclid || lastTouch.gclid) return 'gclid';
      if (firstTouch.gbraid || lastTouch.gbraid) return 'gbraid';
      if (firstTouch.wbraid || lastTouch.wbraid) return 'wbraid';
      
      return 'none';
    } catch (e) {
      log('[TruthLedger] Error getting click ID type:', e);
      return 'none';
    }
  }
  
  /**
   * Get current consent status
   * Returns: 'granted', 'denied', 'unknown'
   */
  function getConsentStatus() {
    try {
      var stored = AttributionStorage.read();
      if (!stored) return 'unknown';
      
      return stored.consentMeta?.status || 'unknown';
    } catch (e) {
      log('[TruthLedger] Error getting consent status:', e);
      return 'unknown';
    }
  }
  
  /**
   * Get all Truth Ledger fields as a single object
   * Useful for sending to GA4
   */
  function getAllFields() {
    return {
      tl_paid_flag: getPaidFlag(),
      tl_click_id_type: getClickIdType(),
      tl_consent_status: getConsentStatus(),
    };
  }
  
  return {
    getPaidFlag: getPaidFlag,
    getClickIdType: getClickIdType,
    getConsentStatus: getConsentStatus,
    getAllFields: getAllFields
  };
  
})();